var _path, _path2, _path3, _g, _g2, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "logos:skype",
    clipPath: "url(#clip0_301_25547)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4165 8.99419C15.4631 8.66744 15.4872 8.33787 15.4886 8.00781C15.4885 6.0209 14.6992 4.11538 13.2942 2.71042C11.8893 1.30547 9.98372 0.516158 7.99681 0.516124C7.66681 0.517499 7.33725 0.541562 7.0105 0.588124C5.16381 -0.407126 2.88287 -0.0728131 1.39956 1.41062C-0.0837542 2.89406 -0.418129 5.17481 0.577121 7.0215C0.530558 7.34825 0.506496 7.67775 0.505058 8.00781C0.505058 12.1454 3.85925 15.4996 7.99681 15.4996C8.32681 15.4982 8.65643 15.4741 8.98318 15.4276C10.8298 16.4228 13.1107 16.0885 14.5941 14.6051C16.0774 13.1217 16.4118 10.8408 15.4165 8.99419Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.74966 9.504C7.36932 9.504 9.49297 7.38035 9.49297 4.76069C9.49297 2.14103 7.36932 0.0173759 4.74966 0.0173759C2.13 0.0173759 0.00634766 2.14103 0.00634766 4.76069C0.00634766 7.38035 2.13 9.504 4.74966 9.504Z",
    fill: "url(#paint0_linear_301_25547)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.2439 15.9983C13.8636 15.9983 15.9872 13.8747 15.9872 11.255C15.9872 8.63534 13.8636 6.51169 11.2439 6.51169C8.62426 6.51169 6.50061 8.63534 6.50061 11.255C6.50061 13.8747 8.62426 15.9983 11.2439 15.9983Z",
    fill: "url(#paint1_linear_301_25547)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_301_25547",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 16,
    height: 17
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.2439 6.51153C10.3959 6.51132 9.56337 6.73905 8.8335 7.1709C10.0544 5.11215 9.55219 2.46634 7.66169 0.998152C5.77125 -0.470161 3.08356 -0.301848 1.39094 1.39078C-0.301623 3.08334 -0.469935 5.77109 0.998315 7.66153C2.4665 9.55203 5.11225 10.0543 7.17113 8.83334C6.078 10.686 6.36844 13.0423 7.87875 14.5741C9.38913 16.1058 11.7411 16.4294 13.609 15.3624C15.4769 14.2954 16.3929 12.105 15.8406 10.026C15.2883 7.94696 13.4062 6.4999 11.2549 6.50046L11.2439 6.51153Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_301_25547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.84665 17.2119C12.7417 17.2119 16.7099 13.2437 16.7099 8.34862C16.7099 3.45359 12.7417 -0.514626 7.84665 -0.514626C2.95161 -0.514626 -1.0166 3.45359 -1.0166 8.34862C-1.0166 13.2437 2.95161 17.2119 7.84665 17.2119Z",
    fill: "url(#paint2_radial_301_25547)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.99675 15.4996C12.1343 15.4996 15.4885 12.1454 15.4885 8.00781C15.4885 3.87023 12.1343 0.516064 7.99675 0.516064C3.85918 0.516064 0.505005 3.87023 0.505005 8.00781C0.505005 12.1454 3.85918 15.4996 7.99675 15.4996Z",
    fill: "url(#paint3_linear_301_25547)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.99675 15.4996C12.1343 15.4996 15.4885 12.1454 15.4885 8.00781C15.4885 3.87023 12.1343 0.516064 7.99675 0.516064C3.85918 0.516064 0.505005 3.87023 0.505005 8.00781C0.505005 12.1454 3.85918 15.4996 7.99675 15.4996Z",
    fill: "url(#paint4_linear_301_25547)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M5.26492 7.088C5.08874 6.75762 5.00094 6.38731 5.01004 6.013C4.99872 5.53991 5.16026 5.07892 5.46442 4.71637C5.78443 4.35531 6.19319 4.08407 6.65023 3.9295C7.14671 3.75426 7.66974 3.66615 8.19623 3.66906C8.54131 3.6667 8.88601 3.69264 9.22685 3.74662C9.46987 3.78734 9.70901 3.84852 9.94173 3.9295C10.1531 4.0025 10.3433 4.12616 10.4959 4.28969C10.6123 4.42089 10.6755 4.59085 10.6732 4.76625C10.6774 4.85821 10.6635 4.9501 10.6321 5.03664C10.6007 5.12318 10.5525 5.20266 10.4903 5.2705C10.4322 5.33232 10.3617 5.38108 10.2834 5.41356C10.205 5.44603 10.1207 5.46148 10.0359 5.45888C9.91726 5.45711 9.80026 5.4307 9.69235 5.38131C9.43133 5.26569 9.1629 5.16755 8.88885 5.08756C8.63391 5.02091 8.37108 4.98925 8.1076 4.99344C7.76611 4.98198 7.42824 5.06642 7.13229 5.23719C7.00772 5.31285 6.90592 5.42077 6.83765 5.54954C6.76937 5.6783 6.73716 5.82312 6.74442 5.96869C6.74241 6.15802 6.81393 6.34076 6.94392 6.47844C7.10293 6.64246 7.29077 6.77582 7.49804 6.87187C7.72523 6.98269 8.05217 7.13231 8.5176 7.32075L8.66167 7.37612C9.10122 7.54365 9.52266 7.7553 9.91954 8.00781C10.2357 8.2128 10.5026 8.48531 10.7009 8.80575C10.8958 9.1419 10.9936 9.52555 10.9835 9.914C10.9992 10.3899 10.8612 10.8581 10.59 11.2494C10.3118 11.6259 9.92511 11.9082 9.48179 12.0585C8.95751 12.2455 8.40361 12.3356 7.8471 12.3244C7.08623 12.3496 6.32923 12.2058 5.6306 11.9033C5.45165 11.8228 5.29412 11.7013 5.17073 11.5487C5.07371 11.4048 5.0234 11.2346 5.02667 11.0611C5.02059 10.9696 5.03483 10.878 5.06836 10.7928C5.10189 10.7075 5.15388 10.6307 5.2206 10.5679C5.35913 10.4453 5.54007 10.3817 5.72485 10.3906C5.93144 10.3935 6.13447 10.4448 6.31773 10.5402C6.54492 10.651 6.72223 10.7397 6.87185 10.7951C7.02017 10.8578 7.1742 10.906 7.33179 10.9391C7.52625 10.9833 7.72534 11.0038 7.92473 11.0001C8.27764 11.0261 8.62901 10.9324 8.9221 10.7341C9.03281 10.6494 9.12137 10.5391 9.18022 10.4127C9.23908 10.2863 9.26648 10.1475 9.2601 10.0083C9.26544 9.80305 9.1898 9.604 9.04954 9.45413C8.8688 9.26987 8.65916 9.11638 8.42892 8.99975C8.15742 8.85563 7.76954 8.68388 7.27642 8.47331C6.83327 8.2969 6.40828 8.07792 6.00742 7.81944C5.70767 7.62006 5.44635 7.399 5.26492 7.088Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_25547",
    x1: 400.086,
    y1: 5.55757,
    x2: 548.589,
    y2: 943.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00B7F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#009DE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0082D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_301_25547",
    x1: 69.672,
    y1: 718.009,
    x2: 891.992,
    y2: 243.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#007AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0082D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0090DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#00A3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_301_25547",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(859.41 885.81) scale(886.697)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_301_25547",
    x1: 456.543,
    y1: 242.11,
    x2: 1205.72,
    y2: 1539.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B7F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007CC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_301_25547",
    x1: 684.292,
    y1: 1496.09,
    x2: 815.068,
    y2: 3.28804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCF2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_25547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkype);
export default __webpack_public_path__ + "static/media/skype.5ded7e4e2f8db2f77c64b343c80d0c8b.svg";
export { ForwardRef as ReactComponent };